import { ItemCategory } from "./types";

export const categoryLabels: Record<ItemCategory, string> = {
  baby: "Baby & Kids", // Baby Cots, Baby Strollers, Baby High Chairs, Baby Toys
  bedding: "Beds & Bedding", // Beds Frames & Mattresses (also included under Furniture for overlap)
  decor: "Home Decor", // Curtains & Blinds, Wall Art & Frames, Rugs & Carpets, Mirrors
  digital_wears: "Digital Wears & Accessories", // Smart Watches
  electronics: "Electronics & Appliances", // TVs, Fans, ACs, cameras, etc. (generators/inverters/inverter batteries → power_solutions)
  fashion: "Fashion Business Tools", // Fashion Business Tools, Industrial Sewing Machine, Manual Sewing Machine, Mannequines
  fitness: "Sports & Fitness", // Bicycles, Gym Bike, Treadmills
  furniture: "Furniture", // Sofas & Couches, Beds Frames & Mattresses, Wardrobes & Dressers, Tables & Chairs, Shelves
  gaming: "Gaming & Consoles", // Play Station, Snooker
  kitchen: "Kitchen & Dining", // Refrigerators & Freezers, Non-Smart Microwaves, Gas Cookers & Gas Cylinders, Blenders & Food Processors, Cookware & Utensils, Dining Tables & Chairs
  lighting: "Lighting", // Lamps, Light Fixtures, Chandeliers
  personal_computers: "Personal Computers", // Desktop PC, Windows PC, Mac (laptops and desktops)
  phones_tabs: "Phones & Tabs", // iPhone, iPad, Android Phone, Android Tab
  power_solutions: "Power Solutions", // Generators, Inverters, Inverter Batteries
  outdoor: "Outdoor & Garden", // Water Tank, Garden Tools, BBQ Grills
  tools: "Tools & Equipment", // Tool Sets, Ladders
  other: "Other", // Others
};
